import { NavigateFrom } from "./ScreenRouteConstant";

export const ScreenPushBackCode = {
    savedLocationForAddList: 'saved_location_for_address_list',
    savedLocationForCart: 'saved_location_for_OMS_cart',
    fetchedDataForUpsertAdd: 'fetch_location_for_add_address',
    fetchedDataForCompleteProfile: 'fetch_location_for_complete_frofile',
    updateProductCategory: 'update_product_category',
    [NavigateFrom.pharmacy_list_for_search_location]: 'fetch_location_for_pharmacy_list',
    [NavigateFrom.complete_proifle_for_search_location]: 'fetch_location_for_complete_frofile',
    [NavigateFrom.save_location_for_search_locality]: 'fetch_location_for_add_address'
}